<template>

  <div class="user">
    <!--添加任务-->
    <div class="common-seach-wrap">
      <el-form :inline="true" size="small" :model="formInline" class="demo-form-inline">
        <el-form-item label="预警库存名称">
          <el-input placeholder="请输入预警库存名称" v-model="formInline.search">
        
          </el-input>
        </el-form-item>
        <el-form-item >
          <el-button type="primary" icon="el-icon-search" @click="getData">查询</el-button>
        </el-form-item>

      </el-form>
    </div>

    <div class="common-level-rail">
 
      <el-button  size="small" v-if="showBack" type="info" @click="gotoBack">返回上一页</el-button>
    </div>

    <div class="product-content">
      <el-form ref="form" :model="form" label-width="100px">
        <div class="table-wrap">
          <el-table size="small" :data="tableData" border style="width: 100%" v-loading="loading">
      
            <!-- 操作人 (shop_user_id) -->
              <el-table-column prop="shop_user_id" label="操作人"></el-table-column>

              <!-- 现有库存ID (warehouse_inventorys_id) -->
              <el-table-column prop="warehouse_inventorys_id" label="现有库存ID">

                <!-- <template slot-scope="scope">
                  <a @click="jump('/plus/existing_inventory/index')" class="des" style="color: #029eff;">{{ scope.row.warehouse_inventorys_id }}</a>

                </template> -->
              </el-table-column>

              <!-- 备注 (remark) -->
              <el-table-column prop="remark" label="备注"></el-table-column>

          <!-- 状态 (status) -->
          <el-table-column prop="status" label="状态">
              <template slot-scope="scope">
                  <!-- 显示状态 0: 未处理, 1: 已处理 -->
                  <span>{{ scope.row.status === 0 ? '未处理' : '已处理' }}</span>
              </template>
          </el-table-column>

           <el-table-column prop="virtualInventoryAlert" label="状态">

              <template slot-scope="scope">
              <div> 
                <el-switch v-model="scope.row.status" active-color="#13ce66" 
          inactive-color="#ff4949"  @change="handleBlur(scope.row,'status')"
         :active-value="1" :inactive-value="0"></el-switch>
              </div>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-form>
      <!--分页-->
      <div class="pagination">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          background
          :current-page="curPage"
          :page-size="pageSize"
          layout="total, prev, pager, next, jumper"
          :total="totalDataNumber"
        ></el-pagination>
      </div>
    </div>
    

    <el-dialog  style="text-align: center" title="设置标题" :visible.sync="dialogVisible" @close='dialogFormVisible' 
    :close-on-click-modal="false" 
               :close-on-press-escape="false" :append-to-body="true">
    </el-dialog>
  
  </div>
</template>

<script>
  import Warning_inventoryApi from '@/api/warning_inventory.js';

  export default {
    components: {

    },
    inject: ['reload'],
    data() {
      return {
        /*是否加载完成*/
        loading: true,
        /*列表数据*/
        tableData: [],
        /*一页多少条*/
        pageSize: 20,
        /*一共多少条数据*/
        totalDataNumber: 0,
        /*当前是第几页*/
        curPage: 1,
        /*搜索表单对象*/
        form: {},
        formInline: {
          search:""
        },

        open_add:false,
        open_edit:false,
        warning_inventory_id:"",
        dialogVisible:false,
        showBack:false,
      };
    },
    created() {
      if(this.$route.query.is_show && this.$route.query.is_show == 1){
        this.showBack = true;
      }
      /*获取列表*/
      this.getTableList();
    },
    methods: {
      jump(url){
        this.$router.push({
            path: url,
            query: {
            is_show:1
            }
        });
      },
       /*返回上一页面*/
      gotoBack(){
        this.$router.back(-1);
      },
      dialogFormVisible(){
        this.dialogVisible = false;
      },
      setting(e){//预警库存标题设置
        // this.categorya_id = e
        this.dialogVisible = true;
      },
       /*关闭添加*/
    closeAdd(e){
      this.open_add=false;
      this.getTableList();
    },
    closeEdit(e){
      this.open_edit=false;
      this.getTableList();
    },
    getData(){
      this.getTableList();
    },
      /*选择第几页*/
      handleCurrentChange(val) {
        this.curPage = val;
        this.getTableList();
      },

      /*每页多少条*/
      handleSizeChange(val) {
        this.curPage = 1;
        this.pageSize = val;
        this.getTableList();
      },

      /*获取列表*/
      getTableList() {
        let self = this;
        let Params = this.formInline;
        Params.page = self.curPage;
        Params.list_rows = self.pageSize;
        self.loading = true;
        Warning_inventoryApi.list(Params, true)
          .then(data => {
            self.loading = false;
            self.tableData = data.data.list.data;
            self.totalDataNumber = data.data.list.total;
          })
          .catch(error => {
          });
      },

      /*搜索查询*/
      onSubmit() {
        this.curPage = 1;
        this.getTableList();
      },

      /*添加任务*/
      addClick() {
        this.open_add = true
      },

      /*编辑活动*/
      editClick(row) {
        this.warning_inventory_id = row.warning_inventory_id;
        this.open_edit = true
      },

      /*删除*/
      deleteClick(row) {
        let self = this;
        self
          .$confirm('此操作将永久删除该记录, 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          })
          .then(() => {
            Warning_inventoryApi.del(
              {
                warning_inventory_id: row.warning_inventory_id
              },
              true
            )
              .then(data => {
                if (data.code == 1) {
                  self.$message({
                    message: '删除成功',
                    type: 'success'
                  });
                  this.getTableList();
                } else {
                  self.$message.error('错了哦，这是一条错误消息');
                }
              })
              .catch(error => {
              });
          })
          .catch(() => {
          });
      },
      handleBlur(row,key){
        var self = this;
        Warning_inventoryApi.editPart(
              {
                warning_inventory_id: row.warning_inventory_id,
                cond:[
                {
                  'key':key,
                  'val':row[key]
                }
                ]
              },
              true
            )
              .then(data => {
                if (data.code == 1) {
                  self.$message({
                    message: '修改成功',
                    type: 'success'
                  });
  
                } else {
                  self.$message.error('错了哦，这是一条错误消息');
                }
              })
              .catch(error => {
              });

      },
    }
  };
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/plus/warning_inventory/index/index.vue